function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

class CartSlideOver extends HTMLElement {
  constructor() {
    super();

    this.slideOver = document.getElementById("mini-cart");
    // this.onBodyClick = this.handleBodyClick.bind(this);

    this.slideOver.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
  }

  open() {
    this.slideOver.classList.add("animate", "active");

    this.slideOver.addEventListener(
      "transitionend",
      () => {
        this.slideOver.focus();
        trapFocus(this.slideOver);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.slideOver.classList.remove("active");

    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    console.clear();
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionDomElement = document.getElementById(section.id)
      if (sectionDomElement) {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });
    this.open();
    this.debouncedOnChange = debounce((event) => {
      this.handleBodyClick(event);
    }, 300);
    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-slide-over-product",
        section: "cart-slide-over-product",
      },
      {
        id: "cart-slide-over-button",
        section: "cart-slide-over-button",
      },
      {
        id: "cart-slide-over-total",
        section: "cart-slide-over-total",
      },
      {
        id: "cart-express-count",
        section: "cart-express-count",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
      }
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    // if (target !== this.slideOver && !target.closest("mini-cart")) {
    //   this.close();
    // }

    this.updateQuantity(
      evt.target.dataset.index,
      evt.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  //updatequantitymeh
  updateQuantity(line, quantity, name) {
    /**
     * Aumenta o disminuye un item del carrito, recibiendo en que linea se encuentra y su cantidad
     * para hacer un server side render con la info actualizada
     */
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedStateB = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id);
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedStateB.sections[section.section],
              section.selector
            );
          }
        });
        // const lineItem = document.getElementById(`CartItem-${line}`);
        // if (lineItem && lineItem.querySelector(`[name="${name}"]`))
        //   lineItem.querySelector(`[name="${name}"]`).focus();
        // this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        document.getElementById("cart-errors").textContent =
          window.cartStrings.error;
        this.disableLoading();
      });
  }

  enableLoading(line) {
    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );
    document
      .getElementById("cart-slide-over-product")
      .classList.add("cart__items--disabled");
    this.querySelectorAll(
      `[data-item="CartItem-${line}"] .loading-overlay`
    ).forEach((overlay) => overlay.classList.remove("hidden"));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
  //

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-slide-over", CartSlideOver);
